import SelectPackageRuleConstants from "./select-package-rule-constants";

export default SelectPackageRuleConstants;